"use strict";
let baseJumpUrl = "";
if (location.host == "h5.bitheroai.com") {
  // 正式站
  baseJumpUrl = "https://api.bitheroai.com/index.php?s=/api/";
} else {
  baseJumpUrl = "https://aiapi.bc2c.cn/index.php?s=/api/";
}
export default {
  baseJumpUrl: baseJumpUrl,
};
